import type { TFunction } from "i18next";

export const SEATING_ERROR_CODES = {
  linkedCompanion: "linkedCompanion",
  seatOutOfRange: "seatOutOfRange",
  seatDeactivated: "seatDeactivated",
  missingPreviousTable: "missingPreviousTable",
  targetTableNotFound: "targetTableNotFound",
  previousTableNotFound: "previousTableNotFound",
  noRoomForParty: "noRoomForParty",
  noRoomForPartyGeneric: "noRoomForPartyGeneric",
  cannotRelocateParties: "cannotRelocateParties",
  tableNotFound: "tableNotFound",
  addTableFailed: "addTableFailed",
  moveSeatFailed: "moveSeatFailed",
  maxPlansReached: "maxPlansReached",
  planNameEmpty: "planNameEmpty",
  cannotDeleteLastPlan: "cannotDeleteLastPlan",
} as const;

export type SeatingErrorCode = keyof typeof SEATING_ERROR_CODES;

export class SeatingError extends Error {
  readonly code: SeatingErrorCode;
  readonly params?: Record<string, unknown>;

  constructor(code: SeatingErrorCode, params?: Record<string, unknown>) {
    super(code);
    this.name = "SeatingError";
    this.code = code;
    this.params = params;
  }
}

export function isSeatingError(err: unknown): err is SeatingError {
  return err instanceof SeatingError;
}

export function seatingErrorMessage(err: unknown, t: TFunction): string {
  if (isSeatingError(err)) {
    const key = `seating.errors.${err.code}`;
    const msg = t(key, err.params ?? {});
    if (msg !== key) return msg;
  }
  if (err instanceof Error && err.message.startsWith("seating.errors.")) {
    const msg = t(err.message);
    if (msg !== err.message) return msg;
  }
  return t("seating.errors.generic");
}
